import { isWithinInterval, parse } from 'date-fns'

/** Export Webpack DefinePlugin vars */
declare var process: {
  env: {
    WEBSITE_URL: string
    API_URL: string
    HEADLESS: string
    ENABLE_TRACKING: string
    SRPRS_ENV: string
    SRPRS_DEV: string
    SRPRS_GIFTCARD_CAMPAIGN?: 'thanksgiving'
    SRPRS_SANDBOX: string
  }
}

declare const __webpack_hash__: string

export const WEBSITE_URL = process.env.WEBSITE_URL
export const API_URL = process.env.API_URL
export const HEADLESS = `${process.env.HEADLESS}` === `true`
export const ENABLE_TRACKING = `${process.env.ENABLE_TRACKING}` === `true`
export const SRPRS_ENV = process.env.SRPRS_ENV
export const SRPRS_DEV = `${process.env.SRPRS_DEV}` === `true`
export const SRPRS_SANDBOX = `${process.env.SRPRS_SANDBOX}` === `true`
export const WEBPACK_HASH = __webpack_hash__

export const isThanksgivingCampaign = () => {
  const startDate = parse('01-11-2023', 'dd-MM-yyyy', new Date())
  const endDate = parse('01-01-2024', 'dd-MM-yyyy', new Date())
  return isWithinInterval(new Date(), {
    start: startDate,
    end: endDate,
  })
}

export const SRPRS_GIFTCARD_CAMPAIGN = isThanksgivingCampaign()
  ? 'christmas-campaign'
  : 'default'
